<style scoped>
.footerBox {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  max-width: 7.5rem;
  height: .98rem;
  background: #fff;
  border-top: .01rem solid #E9E9E9;
  box-sizing: border-box;

}

.footerItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: .24rem;
  color: #959595;
  position: relative;
}

.numBox {
  position: absolute;
  width: .25rem;
  height: .25rem;
  background: #E50011;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .16rem;
  color: #fff;
  border-radius: 50%;
  top: -.1rem;
  right: -.1rem;
}

.footerItem.active {
  color: #00C59F;
}

.footerItem.active .f1 {
  background: url("~assets/fa1.png") no-repeat center/cover;
}

.footerItem.active .f2 {
  background: url("~assets/fa2.png") no-repeat center/cover;
}

.footerItem.active .f3 {
  background: url("~assets/fa3.png") no-repeat center/cover;
}

.footerItem.active .f4 {
  background: url("~assets/fa4.png") no-repeat center/cover;
}

.footerItem.active .f5 {
  background: url("~assets/fa5.png") no-repeat center/cover;
}


.footerItemIcon {
  width: .4rem;
  height: .4rem;
  margin-bottom: .1rem;
}

.f1 {
  background: url("~assets/f1.png") no-repeat center/cover;
}

.f2 {
  background: url("~assets/f2.png") no-repeat center/cover;
}

.f3 {
  background: url("~assets/f3.png") no-repeat center/cover;
}

.f4 {
  background: url("~assets/f4.png") no-repeat center/cover;
}

.f5 {
  background: url("~assets/f5.png") no-repeat center/cover;
}
</style>

<template>
  <div class="footerBox">
    <div class="footerItem" :class="{active:active==='1'}" @click="to('')">
      <div class="footerItemIcon f1"></div>
      首页
    </div>
    <div class="footerItem" :class="{active:active==='2'}" @click="to('consult')">
      <div class="footerItemIcon f2"></div>
      咨询
    </div>
    <div class="footerItem" :class="{active:active==='5'}" @click="to('task')" v-if="companyId!='10006'">
      <div class="footerItemIcon f5"></div>
      <div class="numBox" v-if="workCount>0">
        {{ workCount }}
      </div>
      任务
    </div>
    <div class="footerItem" :class="{active:active==='3'}" @click="to('news')">
      <div class="footerItemIcon f3"></div>
      消息
      <div class="numBox" v-if="count>0">
        {{ count }}
      </div>
    </div>
    <div class="footerItem" :class="{active:active==='4'}" @click="to('my')">
      <div class="footerItemIcon f4"></div>
      我的
    </div>
  </div>
</template>

<script>
import {getSources} from "../api";
import {isBlank} from "../utils";

export default {
  props: ['active'],
  data() {
    return {
      count: 0,
      workCount: 0,
      companyId: localStorage.getItem('companyId') ? localStorage.getItem('companyId') : ''
    }
  },
  methods: {
    to(n) {
      this.$router.push(`/${n}`)
    },
    back() {
      var ua = navigator.userAgent;
      if (this.$route.query.type == 1) {
        var isIos = /iPhone/i.test(ua);
        var isAndroid = /Android/i.test(ua);
        isIos && window.webkit.messageHandlers.BackToNormal.postMessage(1);
        isAndroid && XinMaoEap.finshActivity();
      } else {
        history.back()
      }
    },
    async getNoReadCountForDoctor() {
      let id = localStorage.getItem('doctorId')
      // console.log('id', id, 'type', (typeof id))
      if (this.$utils.isBlank(id)) {
        return false
      }
      let data = await getSources("/bear-scale/api/systemMessage/getNoReadCountForDoctor.json", {
        doctorId: id
      });
      if (data.status === 0) {
        this.count = data.count
        this.workCount = data.workCount
      } else if (data.status === -1) {
        alert(data.msg)
        localStorage.clear();
        if (!localStorage.getItem('userId')) {
          this.$router.push(`/login`)
        } else {
          setTimeout(() => {
            this.$router.push(`/login`)
          }, 200)
        }
      }
    },
  },
  mounted() {
    this.getNoReadCountForDoctor()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/footer.vue